<template>
  <v-app>
    <app-toolbar :title-visible="false" />
    <app-footer />
    <v-content>
      <slot />
    </v-content>
  </v-app>
</template>

<script>
import AppToolbar from '../../components/app/AppToolbar'
import AppFooter  from '../../components/app/AppFooter'

export default {
  name      : 'DefaultLayout',
  components: { AppToolbar, AppFooter },
  mixins    : [],
  data () {
    return {}
  },
  computed  : {},
  watch     : {},
  created () {},
  mounted () {},
  updated () {},
  beforeDestroy () {},
  methods   : {}
}

</script>

<style>

</style>
